`
<template>
  <div>
    <Navbar appTitle="新建点巡检" />
    <div
      class="search-content wrap-apply"
      :style="{
        top: GLOBAL.currentEnvironment ? '0' : '',
        height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 1.12rem)',
        paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : '',
      }"
    >
      <van-cell-group style="margin-top: 0.1rem">
        <p class="label required FormTit"><span></span>点巡检设备</p>
        <scanInput
          ref="scanInput"
          :columns="columns"
          @changeScan="changeScan"
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>设备类别</p>
        <van-field
          readonly
          v-model="buildForm.deviceCategoryText"
          placeholder="请先选择点巡检设备"
        />
        <div class="bottomLine"></div>
      </van-cell-group>

      <van-cell-group
        style="margin-top: 0.1rem"
        v-for="(p, i) in messDeviceCheckTaskItemList"
        :key="i"
      >
        <p
          class="label otherText"
          style="display: flex; justify-content: space-between"
        >
          点巡检项目（{{ i + 1 }}）<span
            style="font-weight: 400; color: #ff4d4f"
            @click="messDeviceCheckTaskItemList.splice(i, 1)"
            v-if="messDeviceCheckTaskItemList.length > 1"
            >删除</span
          >
        </p>
        <div class="bottomLine"></div>
        <p class="label required FormTit"><span></span>点巡检项</p>
        <van-field
          readonly
          placeholder="请选择"
          v-model="p.projectText"
          :is-link="!p.projectText"
          @click="projectVisible(i)"
        >
          <div
            slot="right-icon"
            v-show="!!p.projectText"
            @click.stop="handleConfirm('')"
          >
            <img
              src="~@/assets/img/filedClear.png"
              alt=""
              style="width: 0.16rem"
            />
          </div>
        </van-field>
        <div class="bottomLine"></div>
        <p class="label FormTit"><span></span>检查标准</p>
        <van-field
          readonly
          placeholder="请选择点巡检"
          v-model="p.checkStandard"
        />
        <div class="bottomLine"></div>
        <p class="label required FormTit"><span></span>检查结果</p>
        <van-field
          readonly
          :is-link="!p.checkResultsText"
          placeholder="请选择"
          @click="checkResultVisible(i)"
          v-model="p.checkResultsText"
        >
          <div
            slot="right-icon"
            v-show="!!p.checkResultsText"
            @click.stop="handleConfirmCheckResullt('')"
          >
            <img
              src="~@/assets/img/filedClear.png"
              alt=""
              style="width: 0.16rem"
            />
          </div>
        </van-field>
      </van-cell-group>
      <div class="addgoods" @click="messDeviceCheckTaskItemList.push({})">
        <a>+添加</a>
      </div>

      <van-cell-group style="margin-top: 0.1rem">
        <p class="label otherText">其他</p>
        <div class="bottomLine"></div>
        <p class="label">备注</p>
        <van-field
          v-model="buildForm.remark"
          rows="2"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          placeholder="请输入备注"
          show-word-limit
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <!-- <upload iconType="fj" @fileChange="fileChange" :fileIds="attachment" /> -->
        <fileSelector
          iconType="fj"
          :title="'附件'"
          @fileChange="fileChange"
          :fileIds="attachment"
        ></fileSelector>
      </van-cell-group>
      <div class="search-bottoms">
        <span class="btnconfirm" @click="btnConfirm('finish')">提交</span>
      </div>
    </div>
    <van-popup v-model="visibles" position="bottom">
      <van-picker
        :columns="options"
        @confirm="handleConfirm"
        @cancel="visibles = false"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="visibleCheckResullt" position="bottom">
      <van-picker
        :columns="optionCheckResullt"
        @confirm="handleConfirmCheckResullt"
        @cancel="visibleCheckResullt = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>
<script>
import {
  pageQueryDeviceEntity,
  messDeviceMaintainItemList,
} from "@/api/system";
import Navbar from "@/components/navBar/navBar_right";
import scanInput from "@/components/scanCode/scanInput";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import upload from "@/components/upload/upload";
import { APILX } from "@/api/requestLx";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import VanFieldCheckbox from "@/components/ActionSheet/VanFieldCheckbox";
import { messDeviceQueryById } from "@/api/mobile";
// import {} from "@/utils/util";
import Examine from "@/components/examine";
import fileSelector from "@/components/fileSelector.vue";
export default {
  name: "search",
  components: {
    ContactPickers,
    upload,
    VanFieldSelectPicker,
    VanFieldCheckbox,
    Navbar,
    scanInput,
    Examine,
    fileSelector
  },
  data() {
    return {
      visibleCheckResullt: false, //检查结果弹窗
      optionCheckResullt: [
        {
          text: "正常",
          value: "0",
        },
        {
          text: "异常",
          value: "1",
        },
      ],
      deviceId: "",
      visibles: false,
      buildForm: {
        deviceId: undefined,
        deviceCategoryText: "",
        remark: "",
      },
      columns: [],
      deviceList: [], //完整的工单编号列表
      attachment: "", //附件
      formPage: "",
      currentLoginUser: {},
      messDeviceCheckTaskItemList: [{}],
      options: [],
      listIndex: null,
    };
  },
  computed: {},
  created() {
    this.currentLoginUser = JSON.parse(
      localStorage.getItem("pro__Login_Userinfo")
    ).value;
    this.deviceId = this.$route.query.deviceId;
    this.formPage = this.$route.query.formPage;
    if (this.formPage == "scanCode" && this.$route.query.code) {
      this.deviceId = this.$route.query.code.id;
      this.changeScan({ code: this.$route.query.code }, "scan");
    }
    this.getInitData();
  },
  methods: {
    checkResultVisible(i) {
      this.listIndex = i;
      this.visibleCheckResullt = true;
    },
    //选检查结果
    handleConfirmCheckResullt(item) {
      if (!item) {
        this.messDeviceCheckTaskItemList[this.listIndex].checkResults = "";
        this.messDeviceCheckTaskItemList[this.listIndex].checkResultsText = "";
        this.visibleCheckResullt = false;
        this.$forceUpdate();
        return;
      }
      this.messDeviceCheckTaskItemList[this.listIndex].checkResults =
        item.value;
      this.messDeviceCheckTaskItemList[this.listIndex].checkResultsText =
        item.text;
      this.visibleCheckResullt = false;
    },
    // 选择点巡检项
    handleConfirm(v,i) {
      console.log(v, this.listIndex, "vvvvvvv");
      if (!v) {
        this.$nextTick(() => {
          this.messDeviceCheckTaskItemList[i].itemId = "";
          this.messDeviceCheckTaskItemList[i].checkStandard = "";
          this.messDeviceCheckTaskItemList[i].projectText = "";
          this.messDeviceCheckTaskItemList[i].projectCode = "";
          this.messDeviceCheckTaskItemList[i].projectName = "";
          this.messDeviceCheckTaskItemList[i].checkResults = "";
          this.messDeviceCheckTaskItemList[i].checkResultsText =
            "";
          this.visibles = false;
        });
        this.$forceUpdate();

        return;
      }
      let isExist = false;
      this.messDeviceCheckTaskItemList.forEach((item) => {
        //   item.itemId = v.id的话 删除当前数据
        if (item.itemId == v.id) {
          isExist = true;
          return;
        }
      });
      if (!isExist) {
        this.messDeviceCheckTaskItemList[this.listIndex].itemId = v.id;
        this.messDeviceCheckTaskItemList[this.listIndex].checkStandard =
          v.checkStandard;
        this.messDeviceCheckTaskItemList[this.listIndex].projectText = v.text;
        this.messDeviceCheckTaskItemList[this.listIndex].projectCode =
          v.projectCode;
        this.messDeviceCheckTaskItemList[this.listIndex].projectName =
          v.projectName;
        this.messDeviceCheckTaskItemList[this.listIndex].checkResults = "";
        this.messDeviceCheckTaskItemList[this.listIndex].checkResultsText = "";
        this.visibles = false;
      } else {
        this.$toast("该项目已存在");
        this.messDeviceCheckTaskItemList.splice(this.listIndex, 1);
        this.visibles = false;
      }
    },
    projectVisible(i) {
      this.visibles = true;
      this.listIndex = i;
    },
    //页面加载请求数据
    getInitData() {
      APILX.messDeviceList({ pageSize: 999, pageNo: 1 }).then((res) => {
        if (res.success) {
          this.deviceList = res.result.records;
          this.columns = [];
          for (let item of res.result.records) {
            let obj = {
              key: `${item.deviceCode}-${item.deviceName}`,
              value: item.id,
              deviceCategoryText: item.deviceCategoryText,
            };
            this.columns.push(obj);
          }
        } else {
          this.$toast(res.message);
        }
      });
      APILX.messCheckItemList({ pageSize: 999, pageNo: 1 }).then((res) => {
        if (res.result.records) {
          for (let i = 0; i < res.result.records.length; i++) {
            let t = res.result.records[i];
            t.text = `${t.projectCode}-${t.projectName}`;
            t.value = t.id;
            this.options.push(t);
          }
        }
      });
    },
    changeScan(v, opratorType) {
      console.log(v, "获取扫码组件数据");
      //value是下拉选择后值,code是扫码获得的值，根据qrcode判断是否隐藏当前页面只显示相机页
      if (opratorType == "select" && this.buildForm.deviceId != v.value) {
        this.buildForm.deviceId = v.value;
        this.buildForm.deviceCategoryText = v.deviceCategoryText || "--";
        console.log(this.buildForm);
      }
      if (opratorType == "scan") {
        if (v.code.EntityType != "device") {
          this.$toast("请扫正确二维码");
          return;
        }
        this.buildForm.deviceId = v.code.id;
        let obj = {
          id: v.code.id, // 设备id,用id查设备详情做回显
        };
        messDeviceQueryById(obj).then((res) => {
          if (res.code == 200) {
            this.buildForm.deviceCategoryText =
              res.result.deviceCategoryText || "--";
            let scanObj = {
              id: this.buildForm.deviceId,
              orderCode: `${res.result.deviceCode}-${res.result.deviceName}`,
            };
            this.$refs.scanInput.propValue(scanObj);
          }
        });
      }
    },
    fileChange(ids) {
      this.attachment = ids;
    },
    // 提交
    btnConfirm() {
      if (!this.buildForm.deviceId) {
        this.$toast("请选择点巡检设备");
        return;
      }
      for (let i = 0; i < this.messDeviceCheckTaskItemList.length; i++) {
        const item = this.messDeviceCheckTaskItemList[i];
        if (!item.itemId) {
          this.$toast(`点巡检项目（${i + 1}）点巡检项必填`);
          return;
        }
        if (!item.checkResults) {
          this.$toast(`点巡检项目（${i + 1}）检查结果必填`);
          return;
        }
      }
      this.handleSubmit();
    },
    goBack() {
      // 跳转到列表页
      //   this.$router.push({
      //     path: "/inspectionTaskList",
      //   });
      this.$router.go(-1);
    },
    handleSubmit() {
      let messDeviceCheckTaskItemList = this.messDeviceCheckTaskItemList.map(
        (g, i) => {
          return {
            checkResults: g.checkResults,
            itemId: g.itemId,
            projectCode: g.projectCode,
            projectName: g.projectName,
            checkStandard: g.checkStandard,
          };
        }
      );
      let params = {
        ...this.buildForm,
        attachment: this.attachment,
        messDeviceCheckTaskItemList: messDeviceCheckTaskItemList,
      };
      console.log("检查一下参数：", params);
      APILX.messDeviceCheckTaskAdd(params).then((res) => {
        this.loadingSubmit = false;
        if (res.code == 200) {
          this.$toast("点巡检任务新建成功！");
          this.goBack();
        } else {
          this.$antdMessage.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
.search-content {
  //  padding-bottom: 0.5rem;
  position: fixed;
  top: 0.42rem;
  width: 100%;
  height: calc(100vh - 1.12rem);
  background: #f5f5f5;
  overflow: scroll;
  z-index: 99;
  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
}
.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0 0.16rem;
}
.otherText {
  padding-bottom: 0.16rem;
  font-size: 0.16rem;
  font-weight: bold;
  color: #191f25;
}
.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 0.16rem;
  /deep/ .van-cell {
    padding-right: 0;
    width: 2.6rem;
  }
  /deep/ .van-field__control {
    max-width: 3rem;
  }
}
/deep/ .van-nav-bar {
  z-index: 99;
}
.search-bottoms {
  width: 100%;
  height: 0.5rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0rem 0.11rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  font-weight: 500;
  z-index: 9;
  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 0.01rem solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    margin-right: 0.11rem;
    color: #191f25;
  }
  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    color: #ffffff;
  }
}
.addgoods {
  background: #fff;
  font-size: 0.16rem;
  text-align: center;
  height: 0.5rem;
  line-height: 0.5rem;
}
</style>
